// ─────────────────────────────────────────────────────────────────────────────
// Mock Analytics & Smart Insights
// Tuned for current period (May 2026) — slightly more positive mix for a
// healthy-looking dashboard in marketing screenshots.
// ─────────────────────────────────────────────────────────────────────────────

export const mockDashboardInsights = {
  rescode: 1,
  message: 'Insights fetched successfully',
  data: {
    insights: [
      {
        type: 'revenue',
        level: 'green',
        message: 'Revenue increased by 18% compared to April 2026.',
        value: 18,
        tag: 'Growth',
        priority: 'low',
        actionRoute: '/invoice',
      },
      {
        type: 'pending',
        level: 'red',
        message: '3 patients have pending payments above ₹5,000.',
        value: 3,
        tag: 'Risk',
        priority: 'high',
        actionRoute: '/invoice',
      },
      {
        type: 'demand',
        level: 'green',
        message: 'Speech Therapy demand increased 24% in May 2026.',
        value: 24,
        tag: 'Growth',
        priority: 'low',
        actionRoute: '/appointment',
      },
      {
        type: 'cancellation',
        level: 'yellow',
        message: 'Physiotherapy cancellations at 6% in May 2026.',
        value: 6,
        tag: 'Warning',
        priority: 'medium',
        actionRoute: '/appointment',
      },
      {
        type: 'attendance',
        level: 'green',
        message: 'Staff attendance at 92% in May. Only 3 absences recorded.',
        value: 92,
        tag: 'Growth',
        priority: 'low',
        actionRoute: '/employee',
      },
      {
        type: 'patient_growth',
        level: 'green',
        message: 'New patient registrations increased by 31% in May 2026.',
        value: 31,
        tag: 'Growth',
        priority: 'medium',
        actionRoute: '/patient',
      },
      {
        type: 'overdue',
        level: 'red',
        message: '4 invoices overdue by 30+ days. Total outstanding needs attention.',
        value: 4,
        tag: 'Risk',
        priority: 'high',
        actionRoute: '/invoice',
      },
      {
        type: 'expense_ratio',
        level: 'green',
        message: 'Expenses at 62% of revenue in May. Healthy margins.',
        value: 62,
        tag: 'Growth',
        priority: 'low',
        actionRoute: '/invoice',
      },
      {
        type: 'inactive_patients',
        level: 'yellow',
        message: '9 patients inactive for 30+ days. Consider follow-up.',
        value: 9,
        tag: 'Warning',
        priority: 'medium',
        actionRoute: '/patient',
      },
      {
        type: 'salary',
        level: 'green',
        message: 'All staff salary payouts on schedule for May 2026.',
        value: 0,
        tag: 'Growth',
        priority: 'low',
        actionRoute: '/employee',
      },
      {
        type: 'peak_hour',
        level: 'green',
        message: 'Peak session hour: 10:00 with 28 sessions (32% of total) in May.',
        value: 28,
        tag: 'Optimization',
        priority: 'low',
        actionRoute: '/appointment',
      },
    ],
  },
};

export const mockPricingInsights = {
  rescode: 1,
  message: 'Pricing insights fetched successfully',
  data: {
    insights: [
      {
        type: 'discount',
        level: 'yellow',
        message: 'Frequent discounting detected in Speech Therapy (avg 18%).',
        value: 18,
        tag: 'Optimization',
        priority: 'medium',
        actionRoute: '/settings',
      },
      {
        type: 'pricing',
        level: 'yellow',
        message: 'Occupational Therapy revenue per session is 22% below average. Consider revising pricing.',
        value: 1200,
        tag: 'Optimization',
        priority: 'medium',
        actionRoute: '/settings',
      },
      {
        type: 'retention',
        level: 'green',
        message: 'Strong retention: 78% of patients visited 2+ months in last 3 months.',
        value: 78,
        tag: 'Growth',
        priority: 'low',
        actionRoute: '/patient',
      },
    ],
  },
};

export const mockOverdueInvoices = {
  rescode: 1,
  message: 'Overdue invoices fetched successfully',
  data: {
    overdueCount: 3,
    overdueInvoices: [
      {
        invoice_id: 'INV-1001',
        patient_id: '5',
        patient_name: 'Aarav Sharma',
        patient_phone: '9876543210',
        total_amount: 15000,
        paid_amount: 5000,
        remaining_amount: 10000,
        created_at: '2026-03-28',
        days_overdue: 48,
      },
      {
        invoice_id: 'INV-1003',
        patient_id: '8',
        patient_name: 'Priya Patel',
        patient_phone: '9123456780',
        total_amount: 8000,
        paid_amount: 2000,
        remaining_amount: 6000,
        created_at: '2026-04-05',
        days_overdue: 40,
      },
      {
        invoice_id: 'INV-1007',
        patient_id: '12',
        patient_name: 'Ravi Kumar',
        patient_phone: '9988776655',
        total_amount: 12000,
        paid_amount: 6500,
        remaining_amount: 5500,
        created_at: '2026-04-12',
        days_overdue: 33,
      },
    ],
  },
};
